
export default {
  props: {
    text: { type: [Boolean, String], default: false },
    error: { type: Boolean, default: false },
  },
}
